export default {
    FOCUS_AREA: 'focus-area'
}
